import { Component, Input, OnChanges, OnDestroy } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SvgIconService } from '@app/core/services/svg-icon.service';

@Component({
  selector: 'app-svg-icon',
  templateUrl: './svg-icon.component.html',
  styleUrls: ['./svg-icon.component.scss']
})
export class SvgIconComponent implements OnChanges, OnDestroy {

  @Input() name!: string;
  @Input() color?: string;
  @Input() size = '1em';

  svg: SafeHtml | null = null;

  private destroy$ = new Subject<void>();
  private lastName: string | null = null;

  constructor(
    private icons: SvgIconService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnChanges(): void {
    if (!this.name) { this.svg = null; return; }
    if (this.lastName === this.name) return;
    this.lastName = this.name;

    this.icons.getCleanSvg(this.name)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (cleaned: string) => {
          this.svg = this.sanitizer.bypassSecurityTrustHtml(cleaned);
        },
        error: err => {
          console.error('[SvgIcon] error loading', this.name, err);
          this.svg = null;
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
